import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetSellerOfferOptionsArgs, GetSellerOfferOptionsResp } from '../types/seller-offer-options'
import {
  GetOfferRequestOptionsArgs,
  GetOfferRequestOptionsResp,
} from '../types/offer-request-options'
import {
  AcceptOfferArgs,
  CreateOfferArgs,
  CreateOfferRequestResp,
  CreateOfferResp,
  RejectOfferArgs,
} from '../types/offer'

export const getSellerOfferOptions = ({ transactionId }: GetSellerOfferOptionsArgs) =>
  api.get<GetSellerOfferOptionsResp>(`/transactions/${transactionId}/offers/seller_options`)

export const getOfferRequestOptions = ({ itemPrice, sellerId }: GetOfferRequestOptionsArgs) =>
  api.post<GetOfferRequestOptionsResp>('/offers/request_options', {
    price: {
      amount: itemPrice.amount,
      currency_code: itemPrice.currencyCode,
    },
    seller_id: sellerId,
  })

export const acceptOffer = ({ transactionId, offerRequestId }: AcceptOfferArgs) =>
  api.put(`/transactions/${transactionId}/offer_requests/${offerRequestId}/accept`)

export const rejectOffer = ({ transactionId, offerRequestId }: RejectOfferArgs) =>
  api.put(`/transactions/${transactionId}/offer_requests/${offerRequestId}/reject`)

export const createOffer = ({ transactionId, price, currency }: CreateOfferArgs) =>
  api.post<CreateOfferResp>(`/transactions/${transactionId}/offers`, {
    offer: {
      price,
      currency,
    },
  })

export const createOfferRequest = ({ price, currency, transactionId }: CreateOfferArgs) =>
  api.post<CreateOfferRequestResp>(`/transactions/${transactionId}/offer_requests`, {
    offer_request: {
      price,
      currency,
    },
  })
